import { render, staticRenderFns } from "./Pembelian.vue?vue&type=template&id=3eb92e1e&"
import script from "./Pembelian.vue?vue&type=script&lang=js&"
export * from "./Pembelian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports